import { useRef } from "react";

// Renderizza un'immagine con callout numerati (pallini / riquadri / frecce).
// Modalità view: sola lettura. Modalità edit: click sull'immagine aggiunge un callout.
export default function CalloutImage({ src, callouts = [], editable = false, onAddCallout, activeId, onSelect }) {
  const ref = useRef();

  const handleClick = (e) => {
    if (!editable || !onAddCallout) return;
    const rect = ref.current.getBoundingClientRect();
    const x = ((e.clientX - rect.left) / rect.width) * 100;
    const y = ((e.clientY - rect.top) / rect.height) * 100;
    onAddCallout({ x: Math.round(x * 10) / 10, y: Math.round(y * 10) / 10 });
  };

  return (
    <div
      ref={ref}
      onClick={handleClick}
      className={`relative w-full overflow-hidden rounded-lg border border-slate-200 ${editable ? "cursor-crosshair" : ""}`}
      data-testid="callout-image"
    >
      <img src={src} alt="" className="block w-full select-none" draggable={false} />
      {callouts.map((c) => {
        const color = c.color || "#4f46e5";
        const isActive = activeId && c.id === activeId;
        if (c.shape === "box") {
          return (
            <div key={c.id || c.n} onClick={(e) => { e.stopPropagation(); onSelect && onSelect(c); }}
              className="absolute" style={{ left: `${c.x}%`, top: `${c.y}%`, width: `${c.w || 18}%`, height: `${c.h || 12}%`, border: `2px solid ${color}`, borderRadius: 4, boxShadow: isActive ? `0 0 0 2px #fff, 0 0 0 4px ${color}` : "none" }}>
              <span className="absolute -left-2 -top-3 flex h-5 w-5 items-center justify-center rounded-full text-[11px] font-bold text-white" style={{ backgroundColor: color }}>{c.n}</span>
            </div>
          );
        }
        return (
          <span key={c.id || c.n} onClick={(e) => { e.stopPropagation(); onSelect && onSelect(c); }}
            className="absolute flex h-6 w-6 -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-full text-[12px] font-bold text-white ring-2 ring-white"
            style={{ left: `${c.x}%`, top: `${c.y}%`, backgroundColor: color, boxShadow: isActive ? `0 0 0 3px ${color}55` : "0 1px 4px rgba(0,0,0,.3)", cursor: onSelect ? "pointer" : "default" }}>
            {c.shape === "arrow" ? "➤" : c.n}
          </span>
        );
      })}
    </div>
  );
}
